/**
 * Application-wide constants
 * Centralized location for magic numbers and strings to improve maintainability
 */

export const TIME_CONSTANTS = {
	DAYS_30: 30,
	DAYS_28: 28,
	DAYS_14: 14,
	DAYS_7: 7,
	ACTIVE_THRESHOLD_DAYS: 14,
	CHECKIN_ANALYSIS_DAYS: 28,
	REFLECTION_ANALYSIS_DAYS: 28,
} as const;

export const VALIDATION_CONSTANTS = {
	GROUP_NAME_MAX_LENGTH: 100,
	GROUP_DESCRIPTION_MAX_LENGTH: 500,
	TOPIC_NAME_MAX_LENGTH: 100,
	TOPIC_DESCRIPTION_MAX_LENGTH: 1000,
	EMAIL_MAX_LENGTH: 255,
	MIN_PASSWORD_LENGTH: 8,
} as const;

export const ACTIVITY_THRESHOLDS = {
	HIGH_ACTIVITY_REFLECTIONS: 1,
	HIGH_ACTIVITY_CHECKINS_WEEK1: 3,
	HIGH_ACTIVITY_CHECKINS_WEEK2: 3,
	MEDIUM_ACTIVITY_CHECKINS: 3,
	TOTAL_ACTIVITY_HIGH: 15,
	TOTAL_ACTIVITY_MEDIUM: 5,
} as const;

export const PROGRESS_SCORING = {
	MAX_SCORE: 100,
	ACTIVITY_DIVISOR: 20, // totalActivity / 20 * 100
} as const;
